module.exports = __webpack_public_path__ + "static/img/map-filled.4c788f23.png";